var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftTeamsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2500,
  height: 2458,
  viewBox: "-0.13 0 32.423 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 6,
  r: 4.667,
  fill: "#7b83eb"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.667 7H12.44l.021.093.002.008.022.086A4.67 4.67 0 0 0 18 10.559V8.333A1.337 1.337 0 0 0 16.667 7",
  opacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.667 8h-2.884A4.67 4.67 0 0 0 17 10.667V9.333A1.337 1.337 0 0 0 15.667 8",
  opacity: 0.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 7.5,
  r: 3.5,
  fill: "#5059c9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#5059c9",
  d: "M30.5 12h-7.861a.64.64 0 0 0-.64.64v8.11a5.12 5.12 0 0 0 3.967 5.084A5.006 5.006 0 0 0 32 20.938V13.5a1.5 1.5 0 0 0-1.5-1.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7b83eb",
  d: "M25 13.5V23a7.995 7.995 0 0 1-14.92 4 7 7 0 0 1-.5-1 8 8 0 0 1-.33-1A8.2 8.2 0 0 1 9 23v-9.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.667 8h-2.884A4.67 4.67 0 0 0 17 10.667V9.333A1.337 1.337 0 0 0 15.667 8",
  opacity: 0.2
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18 12v12.67a1.32 1.32 0 0 1-1.04 1.29 1 1 0 0 1-.29.04H9.58a8 8 0 0 1-.33-1A8.2 8.2 0 0 1 9 23v-9.5a1.5 1.5 0 0 1 1.5-1.5z",
  opacity: 0.1
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17 12v13.67a1 1 0 0 1-.04.29A1.32 1.32 0 0 1 15.67 27h-5.59a7 7 0 0 1-.5-1 8 8 0 0 1-.33-1A8.2 8.2 0 0 1 9 23v-9.5a1.5 1.5 0 0 1 1.5-1.5z",
  opacity: 0.2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M17 12v11.67A1.336 1.336 0 0 1 15.67 25H9.25A8.2 8.2 0 0 1 9 23v-9.5a1.5 1.5 0 0 1 1.5-1.5z",
  opacity: 0.2
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 12A1.5 1.5 0 0 0 9 13.5V23a8.2 8.2 0 0 0 .25 2h5.42A1.336 1.336 0 0 0 16 23.67V12z",
  opacity: 0.2
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#4b53bc",
  d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.98 12.975H8.99v8.02H7.028v-8.02H4.02v-1.97h7.96z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));
export { SvgMicrosoftTeamsIcon as ReactComponent };
export default __webpack_public_path__ + "48cb6b08b5df2fc49154caafc44aafee.svg";